import "../../../scss/packaging-requirements.scss";
import { FiCheck, FiInfo } from "react-icons/fi";
import { Table } from "react-bootstrap";
import MessageBlock from "../common/MessageBlock";

const PackagingRequirements = (props) => {
  return (
    <div className={"packaging-requirements d-flex flex-column"}>
      <h2>Packaging Requirements</h2>
      <MessageBlock
        icon={<FiInfo />}
        message={
          "Packaging rules must be followed or the carrier may refuse to " +
          "take the shipment and/or the package may be ineligible for insurance or claims coverage."
        }
      />
      <section className={"d-flex flex-column"}>
        <h3>Classification of Shipments</h3>
        <Table>
          <thead>
            <tr>
              <td>Category</td>
              <td>Examples</td>
              <td>Packaging Type</td>
            </tr>
          </thead>
          <tr>
            <td>Fragile Items</td>
            <td>TVs, Glassware, Electronics, Home Appliances</td>
            <td>
              Protective foam, bubble wrap, corner guards, double-wall boxes
            </td>
          </tr>
          <tr>
            <td>Non-Fragile Items</td>
            <td>Clothes, Books, Shoes, Accessories</td>
            <td>Poly mailers, single-wall boxes</td>
          </tr>
          <tr>
            <td>Liquid Items</td>
            <td>Detergents, Oils, Toiletries</td>
            <td>Leak-proof containers, sealed liners, absorbent padding</td>
          </tr>
          <tr>
            <td>Bulk/Heavy Items</td>
            <td>Furniture, Machinery</td>
            <td>Crating, strapping, shrink-wrapped pallets</td>
          </tr>
        </Table>
      </section>
      <section className={"d-flex flex-column"}>
        <h3>Approved Packaging Materials</h3>
        <Table>
          <thead>
            <tr>
              <td>Material Type</td>
              <td>Examples/Description</td>
              <td>Purpose</td>
            </tr>
          </thead>
          <tr>
            <td>Primary</td>
            <td>Bubble wrap, foam inserts, shrink film</td>
            <td>Product-level protection</td>
          </tr>
          <tr>
            <td>Secondary</td>
            <td>Corrugated boxes, molded pulp trays</td>
            <td>Shock absorption and grouping</td>
          </tr>
          <tr>
            <td>Ternary</td>
            <td>Pallets, stretch wrap, strapping</td>
            <td>Bulk protection and stacking</td>
          </tr>
          <tr>
            <td>Support</td>
            <td>Packing tape, labels, silica gel, waterproof pouches</td>
            <td>Sealing and documentation</td>
          </tr>
        </Table>
      </section>

      <section className={"d-flex flex-column"}>
        <h3>Packaging Procedure</h3>
        <div>
          <h4>Step 1: Product Preparation</h4>
          <ul>
            <li>Verify item condition before packing.</li>
            <li>
              Remove dust, stickers, or accessories that may cause scratches.
            </li>
            <li>
              Take product photos before packaging (especially for fragile
              items).
            </li>
          </ul>
        </div>
        <div>
          <h4>Step 2: Inner Packaging</h4>
          <ul>
            <li>Wrap the item with protective film or bubble wrap.</li>
            <li>Add foam padding or air column bags for electronics.</li>
            <li>
              Secure fragile parts (e.g., TV stands, glass panels) separately.
            </li>
          </ul>
        </div>
        <div>
          <h4>Step 3: Outer Packaging</h4>
          <ul>
            <li>
              Use double-wall corrugated cartons for all fragile or valuable
              items.
            </li>
            <li>Fill voids with air cushions or foam peanuts.</li>
            <li>
              Seal with heavy-duty tape on all seams using the “H” sealing
              method.
            </li>
          </ul>
        </div>
        <div>
          <h4>Step 4: Labeling</h4>
          <ul>
            <li>Place shipping labels on the largest flat surface.</li>
            <li>
              Affix <b>“FRAGILE”</b> or <b>“HANDLE WITH CARE”</b> stickers for
              sensitive shipments.
            </li>
            <li>
              Affix <b>“this side up”</b> or for items that need to remain{" "}
              <b>upright</b> (e.g. fridges)
            </li>
            <li>
              Insert documentation (invoice, delivery note) inside waterproof
              pouches.
            </li>
          </ul>
        </div>
        <div>
          <h4>Step 5: Final Check</h4>
          <ul>
            <li>Shake test: ensure no movement inside the package.</li>
            <li>
              Verify label accuracy (destination, contact, and tracking number).
            </li>
            <li>Record package condition photos before dispatch.</li>
          </ul>
        </div>
      </section>
      <section className={"d-flex flex-column"}>
        <h3>Quality Control Checklist</h3>
        <div>
          <p>
            <FiCheck />
            Correct packaging materials used.
          </p>
          <p>
            <FiCheck />
            Proper sealing (no exposed edges).
          </p>
          <p>
            <FiCheck />
            Weight evenly distributed.
          </p>
          <p>
            <FiCheck />
            Label clearly visible and readable.
          </p>
          <p>
            <FiCheck />
            Product images attached to job record (for insurance traceability).
          </p>
        </div>
      </section>
    </div>
  );
};

export default PackagingRequirements;
